module.exports = __webpack_public_path__ + "img/table-delr-icon-white.830518b1.svg";